import * as React from "react"

const Spacer = ({height,className}) => (
  <div className={"spacer"+(height ? ' double':'') + ' ' + className}></div>
)

export default Spacer
